// @ts-ignore
import { useEffect, useState } from "react";

function LogDetail({ detail }: any) {
  const [data, setData] = useState<any>({});

  useEffect(() => {
    setData(detail);
  }, [detail]);


  const stylesheet = `
    @media (max-width: 768px) {
      .value {
        textAlign: left !important;
      }
    }
  `;

  document.head.insertAdjacentHTML("beforeend", `<style>${stylesheet}</style>`);

  return (
    // @ts-ignore
    <div className="container">
      <h1 className="header">Log Detail</h1>
      <div className="item">
        <label className="label">ID:</label>
        <span className="value">{data.id}</span>
      </div>
      <div className="item">
        <label className="label">Timestamp:</label>
        <span className="value">{data.timestamp}</span>
      </div>
      <div className="item">
        <label className="label">GET Params:</label>
        <span className="value">{data.get_params}</span>
      </div>
      <div className="item">
        <label className="label">POST Body:</label>
        <code className="value">
          
          {data.post_body}
          </code>
      </div>
    </div>
  );
}

export default LogDetail;
